import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Keeps technical identifiers hidden unless support needs them. */
@Component({
  selector: 'app-cue-technical-details',
  templateUrl: './cue-technical-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CueTechnicalDetailsComponent {
  @Input()
  public details = '';
}
